/* eslint-disable */
import { InputLabel, MenuItem, Select } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import dayjs from 'dayjs'
import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'
import React, { useState } from 'react'

import { getProgramCost, fetchStandard } from 'api'
import { TextField } from 'app/components/generic/FormElements'
import { getWidgetTypeName, navigationPaths } from 'app/config'
import constants from 'app/constants'
import { createScheduleData, eventAlert } from 'app/helpers'
import { validateNotEmpty } from 'app/validators'
import { sentryLogger } from 'sentry'
import { InvalidDOBLink } from './styles'

const ExplorationForm = (props) => {
  const { formData } = props
  const students = formData?.students
  const { errors, values, setFieldValue } = useFormikContext()
  const [programEndDateList, setProgramEndDateList] = useState([])
  const [standardsWithRange, setStandardsWithRange] = useState([])

  React.useEffect(() => {
    if (values?.program && values?.start_date) {
      const schedule_events = createScheduleData(values?.start_date)
      setProgramEndDateList(schedule_events)
    }
  }, [values?.child_name, values?.start_date])

  React.useEffect(() => {
    ;(async () => {
      try {
        const response = await fetchStandard({
          queries: { include_is_range: true, is_range: true }
        })
        setStandardsWithRange(response?.results || [])
      } catch (err) {
        sentryLogger(err)
      }
    })()
  }, [])

  const studentSelected = (e) => {
    setFieldValue('student', e.target?.value)
  }

  React.useEffect(() => {
    ;(async () => {
      if (values?.program && values?.start_date) {
        try {
          const queries = {
            start_date: values?.start_date,
            student_uuid: values?.student?.user.uuid,
            program_uuid: values?.program?.uuid
          }
          const cost = await getProgramCost({ queries })
          setFieldValue('program_fee', cost?.cost)
          setFieldValue('program_end_date', cost?.end_date)
        } catch (err) {
          sentryLogger(err)
          eventAlert(err.message, constants.ERROR)
        }
      }
    })()
  }, [values?.start_date, values?.program_end_date])

  React.useEffect(() => {
    ;(async () => {})()
  }, [values?.student])

  const isAgeEligible = (student) => {
    const dob = student?.user?.date_of_birth
    if (!dob) return false
    const months = dayjs().diff(dayjs(dob), 'month')
    if (Number.isNaN(months)) return false
    console.log('month age of student', months)
    return standardsWithRange?.some((std) => {
      const min = std?.min_month
      const max = std?.max_month
      if (min == null || max == null) return false
      return months >= min && months <= max
    })
  }

  return (
    <>
      <FormControl
        variant="outlined"
        {...(!isEmpty(errors.student) ? { error: true } : null)}
        required>
        <InputLabel>Child Name</InputLabel>
        <Select
          name={'student'}
          label="Child Name"
          validate={validateNotEmpty({ isRequired: true })}
          setFieldValue={setFieldValue}
          onChange={studentSelected}>
          {students.map((item) => {
            const hasInvalidDOB = !item?.user?.date_of_birth
            const eligible = isAgeEligible(item)
            return (
              <MenuItem
                key={item.user.uuid}
                value={item}
                disabled={!eligible && !hasInvalidDOB}
                onMouseDown={(e) => {
                  if (hasInvalidDOB) e.preventDefault()
                }}
                onClick={(e) => {
                  if (hasInvalidDOB) e.preventDefault()
                }}
                style={
                  hasInvalidDOB ? { opacity: 0.6, cursor: 'default' } : {}
                }>
                <>
                  {`${item.user.full_name} (${`${
                    item.standard?.name ? item.standard.name : ''
                  }`})`}
                  {!item?.user?.date_of_birth && (
                    <>
                      {` - Invalid DOB `}
                      <InvalidDOBLink
                        href={`${window.location.origin}${navigationPaths.student}?uuid=${item?.user?.uuid}&editMode=1`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}>
                        {' '}
                        Update
                      </InvalidDOBLink>
                    </>
                  )}
                </>
              </MenuItem>
            )
          })}
        </Select>
        {!isEmpty(errors.student) && (
          <FormHelperText>{errors.student}</FormHelperText>
        )}
      </FormControl>
      <FormControl
        variant="outlined"
        required={true}
        {...(errors.start_date ? { error: true } : null)}>
        <TextField
          name={'start_date'}
          label="Start Date"
          type={getWidgetTypeName('datepicker')}
          variant="outlined"
          required={true}
          {...{
            validate: validateNotEmpty({
              isRequired: true
            })
          }}
          {...{
            InputLabelProps: {
              shrink: true
            }
          }}
          {...{
            inputProps: {
              ...{
                min: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
                max: dayjs().add(3, 'month').format('YYYY-MM-DD')
              }
            }
          }}
          {...(errors.start_date ? { error: true } : null)}
        />
        {errors.start_date && (
          <FormHelperText>{errors.start_date}</FormHelperText>
        )}
      </FormControl>
      <FormControl
        variant="outlined"
        {...(!isEmpty(errors.program_end_date) ? { error: true } : null)}
        required>
        <TextField
          name={'program_end_date'}
          label={'Program End Date'}
          {...{
            InputLabelProps: {
              shrink: true
            }
          }}
          variant="outlined"
          defaultValue={formData?.program_end_date}
          disabled
        />
        {!isEmpty(errors.program_end_date) && (
          <FormHelperText>{errors.program_end_date}</FormHelperText>
        )}
      </FormControl>
      <FormControl
        variant="outlined"
        {...(!isEmpty(errors.program_fee) ? { error: true } : null)}
        required>
        <TextField
          name={'program_fee'}
          label={'Coins Required'}
          variant="outlined"
          defaultValue={formData?.program_fee}
          disabled
        />
        {!isEmpty(errors.program_fee) && (
          <FormHelperText>{errors.program_fee}</FormHelperText>
        )}
      </FormControl>
    </>
  )
}

export default ExplorationForm
